import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface Request {
    limit: string;
    page: number;
    s_bl_no: string;
}
type DataListProps = {
    s_bl_no: string;
    b_file: string;
    s_date: string;
};

interface ResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleBlImages = ({ page, limit, s_bl_no }: Request): UseQueryResult<ResponseData, Error> => {
    let url = enum_api_uri.get_console_bl_images;
    return useQuery({
        queryKey: ["useGetConsoleBlImages", page, limit, s_bl_no],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    page,
                    limit,
                    s_bl_no,
                },
            });
            return response.data.data;
        },
    });
};
